import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./DeviceMapping.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.DEVICE_MAPPING),
  name: SitesRouteNames.SITE_DEVICE_MAPPING,
  component: Component,
} as RouteRecordRaw;
